import { RootState } from 'app/configureStore';
import { ApplicationDocument, DO_APPLICATION_TYPE } from 'client-experience-toolbox';
import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useFormNetworkCalls } from 'utils/useFormNetworkCalls';
import { getFirstIncompleteSection } from 'utils/utils';
import FormPageDisplay from './FormPageDisplay';
import { useParams } from 'react-router-dom';

export const Factoring: FC = () => {
  const dispatch = useDispatch();
  const factoringSection = useSelector((state: RootState) => state.applicationReducer.factoringSection);
  const { id } = useParams();
  const { fetchApplication } = useFormNetworkCalls(DO_APPLICATION_TYPE.FACTORING);
  useEffect(() => {
    // Refreshing the page
    const initializeApplication = async () => {
      const factoringApplication = (await fetchApplication(id!)) as Partial<ApplicationDocument>;
      dispatch({ type: 'SET_FACTORING_APPLICATION', factoringApplication, sectionHasChanged: false });
      dispatch({
        type: 'SET_VERIFIED_DOT',
        verifiedDOT: factoringApplication?.applicationData?.company?.dotNumber,
      });
      const firstIncomplete = getFirstIncompleteSection(factoringApplication);

      // If the user has completed sections and is navigating back to the form, ensure they are directed to the first incomplete section
      if (factoringSection !== firstIncomplete) {
        dispatch({ type: 'SET_FACTORING_SECTION', factoringSection: firstIncomplete });
      }
    };
    id && initializeApplication();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);
  return <FormPageDisplay type={DO_APPLICATION_TYPE.FACTORING} />;
};
